import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { RecipientType } from './recipient.type.enum';
import { NotificationDeliveryMethod } from '@40seas/entities/notifications';

export const RecipientSchema = z.object({
    email: z.string().optional(),
    address: z.string().optional(),
    firstName: z.string().optional(),
    phone: z.string().optional(),
    type: EnumSchema(RecipientType).optional(),
    method: EnumSchema(NotificationDeliveryMethod).optional(),
});

export class Recipient extends FromSchema(RecipientSchema) {
    email?: string;
    address?: string;
    firstName?: string;
    phone?: string;
    slackId?: string;
    type?: RecipientType;
    method?: NotificationDeliveryMethod;
}
